import React, { Component } from 'react';
import { connect } from 'react-redux';

import { history } from 'store';
import * as types from 'misc/types';
import { getText } from 'misc/helpers';
import Timeout from './Timeout';
import SearchBackground from 'images/ico_search.svg';

let minSearchTermLength = 2; // minimum characters required before api search is called
let keypressCooldown = 400; // duration before an api search after a key press

class SearchField extends Component {
    render = () => {
        const { search_results } = this.props;

        const bg_style = {
            backgroundImage: 'url(' + SearchBackground + ')'
        };

        return (
            <React.Fragment>
                <input
                    type="search"
                    onChange={e => this.searchInputChange(e)}
                    style={bg_style}
                    placeholder={getText('_3_1_search', 'Sök')}
                />
                {search_results.data &&
                    search_results.data.filterTag && (
                        <div className="filter-tag" onClick={() => this.removeTag()}>
                            <span>{search_results.data.filterTag.title}</span>
                            <img src="assets/images/archives/ico_clear.svg" alt="" />
                        </div>
                    )}
            </React.Fragment>
        );
    };

    searchInputChange(event) {
        const { search_results } = this.props;
        if (event.target.value !== search_results.data.searchTerm) {
            this.props.clearTimeouts();
            let newSearchTerm = event.target.value;
            this.props.setTimeout(() => {
                this.apiSearch(newSearchTerm);
            }, keypressCooldown);
        }
    }

    removeTag() {
        const { dispatch, sessions, search_results } = this.props;

        history.push('/archives');

        dispatch({ type: types.SAGA_TAGS_GET.REQUEST, customerId: sessions.data.customerId });
        dispatch({
            type: types.SAGA_ARCHIVES_SEARCH_GET.REQUEST,
            customerId: sessions.data.customerId,
            searchTerm: search_results.data.searchTerm
        });
    }

    apiSearch(newSearchTerm) {
        const { dispatch, sessions, search_results } = this.props;

        if (newSearchTerm.length === 0) {
            console.log('Reset results!');
            dispatch({ type: types.ARCHIVES_SEARCH_CLEAR });
        } else if (newSearchTerm.length >= minSearchTermLength) {
            console.log('API SEARCH: ' + newSearchTerm);
            dispatch({
                type: types.SAGA_ARCHIVES_SEARCH_GET.REQUEST,
                customerId: sessions.data.customerId,
                searchTerm: newSearchTerm,
                filterTag: search_results.data.filterTag
            });
        }
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        search_results: state.search_results,
        sessions: state.sessions
    };
};

export default connect(mapStateToProps)(Timeout(SearchField));



// WEBPACK FOOTER //
// ./src/components/archives/SearchField.js